import { Injectable } from '@angular/core';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { ContactObject } from 'src/app/models/orders/order-details-sites/sites-table/sites-contacts-table/contact-object.model';

@Injectable({
    providedIn: 'root'
})

export class OrderDetailsSitesContactsConverter implements Converter<Array<ContactObject>> {

    contactList: Array<ContactObject> = new Array<ContactObject>();
    contact;
    constructor() { }

    convert(input: any): Array<ContactObject> {
        if (isNullOrUndefined(input)) {
            return new Array<ContactObject>();
        }
        this.contactList = new Array<ContactObject>();

        for (this.contact of input.contacts) {

            const completeName = new Array<string>();
            completeName.push(this.contact.firstName); completeName.push(this.contact.secondName);
            completeName.push(this.contact.thirdName);
            this.contactList.push(new ContactObject(completeName.join(' '), this.contact.phone, this.contact.email));
        }
        return this.contactList;
    }
}